import React from 'react';

// Define the CSS animation styles
const animationStyles = `
  @keyframes scaleAnimation {
    0%, 100% { transform: scale(1.03); }
    50% { transform: scale(0.98); }
  }
`;

export default function BlockButton( {block, className, settingsFunnel  } ) {
 
if(block.destinationType === null) {
   block.destinationType = 'step';
}
 


let backgroundColor = '';
let textColor = '';

if (block.buttonColor == 'theme') {
  backgroundColor = settingsFunnel.primaryColor;
  textColor = settingsFunnel.buttonTextColor;
} else if (block.buttonColor == 'blue') {
  backgroundColor = '#2196f3'; // Softer blue
  textColor = '#ffffff';
} else if (block.buttonColor == 'black') {
  backgroundColor = '#222831'; // Off-black for smoothness
  textColor = '#f5f5f5';
} else if (block.buttonColor == 'white') {
  backgroundColor = '#f8fafc'; // Very light gray for less harshness
  textColor = '#222831';
} else if (block.buttonColor == 'red') {
  backgroundColor = '#ef4444'; // Softer red
  textColor = '#ffffff';
} else if (block.buttonColor == 'green') {
  backgroundColor = '#22c55e'; // Softer green
  textColor = '#ffffff';
} else if (block.buttonColor == 'pink') {
  backgroundColor = '#ec4899'; // Softer pink
  textColor = '#ffffff';
} else if (block.buttonColor == 'orange') {
  backgroundColor = '#fb923c'; // Softer orange
  textColor = '#222831';
} else if (block.buttonColor == 'purple') {
  backgroundColor = '#a78bfa'; // Softer purple
  textColor = '#ffffff';
}  
 
let animation = '';
 
if (block.animation) {
  animation = 'transition-transform duration-100';
}

 
 

 
    return (
      <div
      style={{
        animation: block.animation ? 'scaleAnimation 1.5s ease-in-out infinite' : '',
      }}
      >
        {/* Inject CSS animation styles */}
        <style>{animationStyles}</style>
        
     
        <div
        className={`rounded-xl   w-full ${className || 'Continuar'}  ${
          block.id === 'temp-block' ? 'opacity-50 border-2 border-blue-500' : ''
        }`} 
      
      
            >
        <button
          className={`px-3 py-1 rounded-lg w-full h-[70px] font-semibold text ${animation}`} 
          style={{
            backgroundColor: backgroundColor,
            color: textColor,
           
          }}
          id={`button-${block.id}`}
         
        >
          {block.label || 'Continuar'}
        </button>
      </div>
      </div>
    );
}